import FilterSelect from '@/components/filters/FilterSelect';
import SummaryCard from '@/components/cards/SummaryCard';
import LineChart from '@/components/charts/LineChart';
import { SummaryData, TimeRange } from '../constants/types';

interface Props {
  summaryData: SummaryData[];
  chartData: any[];
  timeRange: TimeRange;
  setTimeRange: (v: TimeRange) => void;
  timeRangeOptions: any[];
}

const GamicsSection: React.FC<Props> = ({
  summaryData,
  chartData,
  timeRange,
  setTimeRange,
  timeRangeOptions,
}) => (
  <div className="bg-white p-10 rounded-[24px] space-y-8">
    <div className="flex items-center justify-between">
      <h2 className="text-[32px] font-[700]">Gamics</h2>
      <div className="flex gap-4">
        <FilterSelect value={timeRange} onChange={(e) => setTimeRange(e.target.value)} options={timeRangeOptions} />
      </div>
    </div>
    <div className="grid grid-cols-4 gap-2">
      {summaryData.map((d) => (
        <SummaryCard key={d.label} {...d} />
      ))}
    </div>
    <LineChart chartData={chartData} />
  </div>
);

export default GamicsSection;
